<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span style="font-size: 24px">流程表单</span>
      <div class="head-text" style="float: right">
        <el-input
          style="width: 300px"
          placeholder="请输入名称"
          class="search-input"
          v-model="searchword"
        ></el-input>
        <el-button
          @click="GetFormApply"
          slot="append"
          icon="el-icon-search"
          style="margin-right: 70px"
        ></el-button>

        <el-button
          @click="ApplyType = 1"
          :type="ApplyType == 1 ? 'warning' : 'primary'"
          >我发起的</el-button
        >
        <el-button
          @click="ApplyType = 2"
          :type="ApplyType == 2 ? 'warning' : 'primary'"
          >我审核的</el-button
        >
        <el-button
          @click="ApplyType = 3"
          :type="ApplyType == 3 ? 'warning' : 'primary'"
          >我的抄送</el-button
        >
        <el-button
          @click="addflowChart"
          type="success"
          v-if="
            ($store.state.permissions != null &&
              $store.state.permissions.includes('1024')) ||
            $store.state.isProject
          "
          >新增</el-button
        >
      </div>
    </div>
    <el-table
      :row-class-name="tableRowClassName"
      height="72vh"
      class="table"
      :data="formApplyList"
    >
      <el-table-column align="center" prop="fmap03" label="表单名称">
        <template slot-scope="scope">
          <el-button v-if="scope.row.famp13 == 1" type="text" style="color: red"
            >催！</el-button
          >
          {{ scope.row.fmap03 }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="famp04"
        label="模版名称"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="fmap03"
        label="审核流程"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="user04"
        label="创建人"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="famp10"
        label="创建时间"
      ></el-table-column>
      <el-table-column align="center" prop label="状态">
        <template slot-scope="scope">
          <span>
            {{
              scope.row.famp11 == 1
                ? "审核中"
                : scope.row.famp11 == 2
                ? "已通过"
                : scope.row.famp11 == 3
                ? "已驳回"
                : "已撤回"
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        width="300"
        align="center"
        prop
        label="操作"
      >
        <template slot-scope="scope">
          <div style="display: inline-block" v-if="ApplyType == 1">
            <el-button
              v-if="scope.row.famp11 == 1"
              @click="PressFormApply(scope.row.fmap01)"
              type="warning"
              size="mini"
              >催办</el-button
            >
            <el-button
              v-if="scope.row.famp11 == 4 || scope.row.famp11 == 3"
              @click="editFormApply(scope.row.fmap01, 1)"
              type="primary"
              size="mini"
              >编辑</el-button
            >
            <el-popconfirm
              style="margin-left: 10px"
              confirm-button-text="好的"
              cancel-button-text="不用了"
              icon="el-icon-info"
              icon-color="red"
              @confirm="DelFormApply(scope.row.fmap01)"
              title="确定删除吗？"
            >
              <el-button slot="reference" type="danger" size="mini"
                >删除</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              v-if="scope.row.famp11 == 1"
              style="margin-left: 10px"
              confirm-button-text="好的"
              cancel-button-text="不用了"
              icon="el-icon-info"
              icon-color="red"
              @confirm="CancelFormApply(scope.row.fmap01)"
              title="确定撤回吗？"
            >
              <el-button slot="reference" size="mini" type="danger"
                >撤回</el-button
              >
            </el-popconfirm>
          </div>
          <el-button
            @click="editFormApply(scope.row.fmap01, 2)"
            v-if="ApplyType == 2"
            style="margin-left: 10px"
            type="success"
            size="mini"
            >审核</el-button
          >
          <el-button
            @click="editFormApply(scope.row.fmap01, 3)"
            v-if="ApplyType == 3 || ApplyType == 1"
            style="margin-left: 10px"
            type="primary"
            size="mini"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 20px"
      align="center"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!-- 新增 -->
    <el-drawer
      :withHeader="false"
      :visible.sync="addflowChartShow"
      direction="ttb"
      :before-close="handleClose"
      size="100%"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="选择表单模版" name="first">
          <el-row>
            <el-col :span="12">
              <el-descriptions class="margin-top" :column="1" border>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-user"></i>
                    输入表单名称：
                  </template>
                  <el-input v-model="AddFormApplyParams.name"></el-input>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-user"></i>
                    选择表单模版
                  </template>
                  <el-select
                    style="width: 100%"
                    v-model="AddFormApplyParams.tempId"
                    @change="changeFormTemp"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in formTemplist"
                      :key="index"
                      :label="item.fmtp03"
                      :value="item.fmtp01"
                    ></el-option>
                  </el-select>
                </el-descriptions-item>
              </el-descriptions>
            </el-col>
            <el-col :span="12" style="height: 90vh">
              <iframe
                v-if="formTemp.fmtp05"
                :src="this.$store.state.baseUrl + formTemp.fmtp05"
                width="100%"
                height="100%"
                frameborder="0"
              ></iframe>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="内容完善填写" name="second">
          <el-row>
            <el-col :span="12">
              <el-descriptions class="margin-top" :column="3" border>
                <el-descriptions-item
                  v-for="(item, index) in tempFields"
                  :key="index"
                >
                  <template slot="label">{{ item.fmfd06 }}</template>
                  <!-- 根据 要填写的类型不同，所需要填写的组建不同 -->
                  <!-- 占用 02 -->
                  <!-- 时间 -->
                  <el-date-picker
                    v-if="item.fmfd04 == 2"
                    value-format="yyyy/MM/dd HH:mm:ss"
                    v-model="item.fmfd02"
                    type="datetime"
                    placeholder="选择日期时间"
                  ></el-date-picker>

                  <!-- 文本 地址 电话号码 金额-->
                  <el-input
                    v-model="item.fmfd02"
                    v-if="
                      item.fmfd04 == 4 ||
                      item.fmfd04 == 1 ||
                      item.fmfd04 == 3 ||
                      item.fmfd04 == 5
                    "
                  ></el-input>

                  <!-- 是否选择项 -->
                  <el-radio-group v-if="item.fmfd04 == 6" v-model="item.fmfd02">
                    <el-radio label="是">是</el-radio>
                    <el-radio label="否">否</el-radio>
                  </el-radio-group>
                  <!-- 人员 -->
                  <el-select
                    v-if="item.fmfd04 == 7"
                    filterable
                    v-model="item.fmfd02"
                    multiple
                    size="mini"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item2, index2) in userList"
                      :key="index2"
                      :label="item2.user04"
                      :value="item2.user04"
                    ></el-option>
                  </el-select>

                  <!-- 印章 签名 图片 -->

                  <el-upload
                    v-if="
                      item.fmfd04 == 8 || item.fmfd04 == 9 || item.fmfd04 == 12
                    "
                    class="upload-demo"
                    action="/"
                    :on-change="(file) => changeFile(item, file)"
                    :on-remove="(file) => changeFile(item, file, 1, 2)"
                    :limit="1"
                    :auto-upload="false"
                  >
                    <el-button slot="trigger" size="small" type="text"
                      >选取文件</el-button
                    >
                  </el-upload>
                  <!-- 选择集 视点 -->
                  <el-button
                    v-if="item.fmfd04 == 10 || item.fmfd04 == 11"
                    type="text"
                    @click="changeModelOrView(item, 1)"
                    >{{
                      item.fmfd04 == 10 ? "请选择视点" : "请选择选择集"
                    }}</el-button
                  >
                  <img
                    style="width: 100px"
                    v-if="
                      item.fmfd02 && (item.fmfd04 == 10 || item.fmfd04 == 11)
                    "
                    @click="viewImage(item.fmfd02 ? item.fmfd02 : item.fafd06)"
                    :src="
                      item.fmfd02
                        ? $store.state.baseUrl + item.fmfd02
                        : $store.state.baseUrl + item.fafd06
                    "
                  />
                  <!--  -->
                </el-descriptions-item>
              </el-descriptions>
            </el-col>
            <el-col :span="12" style="height: 90vh">
              <iframe
                v-if="formTemp.fmtp05"
                :src="this.$store.state.baseUrl + formTemp.fmtp05"
                width="100%"
                height="100%"
                frameborder="0"
              ></iframe>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="选择审核流程" name="third">
          <el-row>
            <el-col :span="12">
              <el-select
                style="width: 100%"
                v-model="AddFormApplyParams.auditId"
                @change="GetOneFormAuditFlow"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in AuditFlowList"
                  :key="index"
                  :label="item.fafl03"
                  :value="item.fafl01"
                ></el-option>
              </el-select>
              <el-button
                @click="AddFormApply"
                style="float: right; margin: 10px"
                type="primary"
                size="mini"
                >发布</el-button
              >
            </el-col>
            <el-col :span="12">
              <div
                class="el-card__body"
                v-for="(item, index) in detailList.filter(
                  (ele) => ele.fadt07 == 1
                )"
                :key="item.fadt01"
              >
                <el-card class="card-son" shadow="always">
                  <p v-if="item.fadt05 == 1">会签</p>
                  <p v-else>或签</p>
                  <div class="card-cont">
                    <h4>{{ item.fadt03 }}</h4>
                    <span>{{ item.name }}</span>
                  </div>
                </el-card>
                <i
                  v-if="
                    index !=
                    detailList.filter((ele) => ele.fadt07 == 1).length - 1
                  "
                  class="el-icon-bottom"
                ></i>
              </div>

              <div
                class="el-card__body"
                v-for="item in detailList.filter((ele) => ele.fadt07 == 2)"
                :key="item.fadt01"
              >
                <el-card class="card-son" shadow="always">
                  <p>抄送人员</p>
                  <div class="card-cont">
                    <span>{{ item.name }}</span>
                  </div>
                </el-card>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-drawer>
    <!-- 视点选择集选择 -->
    <el-dialog title="选择" :visible.sync="modelOrView" width="60%">
      <el-row>
        <el-col :span="4">
          <zTree
            :zNodes="zNodes"
            :check="false"
            @getData="getData"
            :options="{
              id: 'ID',
              label: 'label',
              pid: 'ParentId',
              zTreeId: 'modelTree',
              delType: {
                add: false,
                update: false,
                del: false,
              },
            }"
          ></zTree>
        </el-col>
        <el-col :span="20">
          <el-table :data="selectOrViewList" style="width: 100%" height="770">
            <el-table-column prop="name" label="名字">
              <template slot-scope="scope">
                <el-button type="text" @click="bindPicForFmfdObj(scope.row)">{{
                  scope.row.name
                }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 编辑和审核  -->
    <el-dialog
      top="1%"
      :title="ApplyType != 2 ? '详情' : '编辑'"
      :visible.sync="editFormApplyOpen"
      :before-close="handleClose"
      :width="ApplyType != 2 && viewOrEdit == 'view' ? '40%' : '90%'"
    >
      <!-- 只可编辑填写内容 不可编辑选择的模版和流程 -->

      <el-popconfirm
        v-if="ApplyType == 1 && viewOrEdit == 'Edit'"
        style="margin-left: 10px"
        confirm-button-text="好的"
        cancel-button-text="不用了"
        icon="el-icon-info"
        icon-color="red"
        @confirm="UpdateFormApply"
        title="确定提交？"
      >
        <el-button slot="reference" type="primary" size="mini">提交</el-button>
      </el-popconfirm>

      <el-popconfirm
        v-if="ApplyType == 2"
        style="margin-left: 10px"
        confirm-button-text="好的"
        cancel-button-text="不用了"
        icon="el-icon-info"
        icon-color="red"
        @confirm="SubmitAudit(1)"
        title="确定提交？"
      >
        <el-button slot="reference" type="primary" size="mini">提交</el-button>
      </el-popconfirm>
      <el-popconfirm
        v-if="ApplyType == 2"
        style="margin-left: 10px"
        confirm-button-text="好的"
        cancel-button-text="不用了"
        icon="el-icon-info"
        icon-color="red"
        @confirm="SubmitAudit(2)"
        title="确定驳回？"
      >
        <el-button slot="reference" type="primary" size="mini">驳回</el-button>
      </el-popconfirm>

      <el-button
        size="mini"
        type="primary"
        style="margin: 20px"
        @click="openreviewpro"
        >查看审核流程</el-button
      >
      <el-button
        size="mini"
        type="primary"
        style="margin: 20px"
        @click="Auditrecord"
        >查看流程记录</el-button
      >
      <el-button
        size="mini"
        type="primary"
        style="margin: 20px"
        @click="ExportFile"
        >导出源文件</el-button
      >
      <el-row>
        <el-col :span="12" v-if="ApplyType != 3 && viewOrEdit == 'Edit'">
          <el-descriptions class="margin-top" :column="3" border>
            <el-descriptions-item
              v-for="(item, index) in formApplyDetil.FormApplyFields"
              :key="index"
            >
              <template slot="label">{{ item.fafd05 }}</template>
              <!-- 根据 要填写的类型不同，所需要填写的组建不同 -->
              <!-- 占用 02 -->
              <!-- 时间 -->
              <el-date-picker
                v-if="item.fafd03 == 2"
                value-format="yyyy/MM/dd HH:mm:ss"
                v-model="item.fafd06"
                type="datetime"
                placeholder="选择日期时间"
              ></el-date-picker>

              <!-- 文本 地址 电话号码 金额-->
              <el-input
                v-model="item.fafd06"
                v-if="
                  item.fafd03 == 4 ||
                  item.fafd03 == 1 ||
                  item.fafd03 == 3 ||
                  item.fafd03 == 5
                "
              ></el-input>

              <!-- 是否选择项 -->
              <el-radio-group v-if="item.fafd03 == 6" v-model="item.fafd06">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
              <!-- 人员 -->
              <el-select
                v-if="item.fafd03 == 7"
                filterable
                v-model="item.fafd06"
                multiple
                size="mini"
                placeholder="请选择"
              >
                <el-option
                  v-for="item2 in userList"
                  :key="item2.user01"
                  :label="item2.user04"
                  :value="item2.user04"
                ></el-option>
              </el-select>

              <!-- 印章 签名 图片 -->
              <el-upload
                v-if="item.fafd03 == 8 || item.fafd03 == 9 || item.fafd03 == 12"
                class="upload-demo"
                action="/"
                :on-change="(file) => changeFile(item, file, 2)"
                :on-remove="(file) => changeFile(item, file, 2, 2)"
                :limit="1"
                :auto-upload="false"
              >
                <el-button slot="trigger" size="small" type="text"
                  >选取文件</el-button
                >
              </el-upload>
              <!-- 选择集 视点 -->
              <el-button
                v-if="item.fafd03 == 10 || item.fafd03 == 11"
                type="text"
                @click="changeModelOrView(item, 2)"
                >{{
                  item.fafd03 == 10 ? "请选择视点" : "请选择选择集"
                }}</el-button
              >
              <img
                style="width: 100px"
                v-if="
                  item.fafd03 == 8 ||
                  item.fafd03 == 9 ||
                  item.fafd03 == 12 ||
                  item.fafd03 == 10 ||
                  item.fafd03 == 11
                "
                @click="viewImage(item.fafd06)"
                :src="$store.state.baseUrl + item.fafd06"
              />
            </el-descriptions-item>
          </el-descriptions>
        </el-col>
        <el-col
          :span="ApplyType != 2 && viewOrEdit == 'view' ? 24 : 12"
          style="height: 90vh"
        >
          <iframe
            v-if="formApplyDetil.FormApply.famp06"
            :src="this.$store.state.baseUrl + formApplyDetil.FormApply.famp06"
            width="100%"
            height="100%"
            frameborder="0"
          ></iframe>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog title="图片" :visible.sync="viewImageShow" width="50%">
      <img :src="$store.state.baseUrl + imageUrl" style="width: 100%" alt />
    </el-dialog>

    <!-- 查看流程记录 -->
    <el-drawer
      title="流程记录"
      :visible.sync="record"
      direction="rtl"
      :before-close="handleClose"
    >
      <!-- 内容 -->
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in formApplyDetil.FormAuditRecord"
          :key="index"
          :icon="activity.icon"
          :type="activity.type"
          :color="activity.color"
          :size="activity.size"
          :timestamp="activity.farc05"
          >{{ activity.farc03 }}</el-timeline-item
        >
      </el-timeline>
    </el-drawer>

    <!-- 查看审核流程 -->
    <el-dialog
      title="审核流程"
      :visible.sync="reviewprocess"
      width="25%"
      :before-close="handleClose"
    >
      <!-- 内容 -->
      <div
        class="dia-card"
        v-for="(item, index) in formApplyDetil.FormAuditFlow"
        :key="item.id"
      >
        <el-card class="el-body" shadow="always">
          <p v-if="item.fmad05 == 1">会签</p>
          <p v-else>或签</p>
          <div class="card-cont">
            <h4>{{ item.fmad06 }}</h4>
            <span>{{ item.name }}</span>
          </div>
          <div class="div-span">
            <span
              v-if="item.state != ''"
              style="border: 1px solid #94c7fa; color: #94c7fa"
              >{{ item.state }}</span
            >
            <span v-else>{{ item.state }}</span>
          </div>
        </el-card>
        <i
          v-if="index != formApplyDetil.FormAuditFlow.length - 1"
          class="el-icon-bottom"
        ></i>
      </div>

      <!-- 按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="reviewprocess = false">取 消</el-button>
        <el-button type="primary" @click="reviewprocess = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  GetFullFormTemp,
  GetOneFormTemp,
  GetProUsersList,
  GetWorkPlaneTree2,
  FindWorkPlaneModel,
  GetModelSelectOrViewPoint,
  GetFormAuditFlowList,
  GetOneFormAuditFlow,
  AddFormApply,
  GetFormApply,
  PressFormApply,
  FindFormApplyDetail,
  CancelFormApply,
  DelFormApply,
  UpdateFormApply,
  SubmitAudit,
} from "@/setAxios";
import zTree from "@/components/zTree";
import { download } from "@/tools/tool";
export default {
  components: { zTree },
  data() {
    return {
      addflowChartShow: false,
      activeName: "first",
      formTemplist: [],
      formTemp: {},
      AddFormApplyParams: {
        name: "",
        tempId: "",
        auditId: "",
        qid: localStorage.pid,
      },
      value: "",
      value2: "",
      tempFields: [],
      userList: [],
      fmfdObj: {},
      modelOrView: false,
      zNodes: null,
      selectOrViewList: [],
      AuditFlowList: [],
      detailList: [],
      ApplyType: 1,
      searchword: "",
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      formApplyList: [],
      editFormApplyOpen: false,
      formApplyDetil: {
        FormApply: {
          famp06: "",
        },
      },
      addOrEdit: 1,
      viewImageShow: false,
      imageUrl: "",
      SubmitAuditParams: {
        id: "",
        type: "",
        content: "",
        qid: localStorage.pid,
      },
      record: false, //打卡流程记录抽屉
      reviewprocess: false, //审核流程弹窗
      viewOrEdit: "view",
    };
  },
  created() {
    if (this.$route.params) {
      this.pageSize = 100;
      this.pageIndex = 1;
      this.seachword = this.$route.params.fmap03;
      this.ApplyType = this.$route.params.famp11 == 3 ? 3 : 2;
    }
    this.GetFormApply();
  },
  watch: {
    ApplyType() {
      this.GetFormApply();
    },
  },
  methods: {
    ExportFile() {
      var name = this.formApplyDetil.FormApply.famp07;
      var path = this.formApplyDetil.FormApply.famp05;
      try {
        download(
          this.$store.state.baseUrl + path,
          name + path.substr(path.lastIndexOf("."))
        );
      } catch (error) {
        this.$message.error("导出失败");
      }
    },

    tableRowClassName({ row, rowIndex }) {
      if (this.$route.params) {
        let index = this.formApplyList.findIndex(
          (ele) => ele.fmap01 == this.$route.params.fmap01
        );
        if (rowIndex === index) {
          return "warning-row";
        }
        return "";
      }
    },
    async SubmitAudit(type) {
      if (type == 2) {
        this.$prompt("请输入驳回内容", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }).then(async ({ value }) => {
          let fd = new FormData();
          fd.append("content", value);
          this.formApplyDetil.FormApplyFields.forEach((ele) => {
            if (
              ele.fafd03 == 7 &&
              ele.fafd06 &&
              typeof ele.fafd06 == "object"
            ) {
              ele.fafd06 = ele.fafd06.join(",");
            }
            if (ele.fafd06) {
              fd.append(ele.fafd05, ele.fafd06);
            }
          });
          fd.append("qid", localStorage.pid);
          fd.append("id", this.formApplyDetil.FormApply.fmap01);
          fd.append("type", type);
          const loading = this.$loading({
            lock: true,
            text: "处理中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let res = await SubmitAudit(fd);
          loading.close();
          if (res.Code > 0) {
            this.$message.success("驳回成功");
            this.editFormApplyOpen = false;
            this.GetFormApply();
          }
        });
      } else {
        let fd = new FormData();
        this.formApplyDetil.FormApplyFields.forEach((ele) => {
          if (ele.fafd03 == 7 && ele.fafd06 && typeof ele.fafd06 == "object") {
            ele.fafd06 = ele.fafd06.join(",");
          }
          if (ele.fafd06) {
            fd.append(ele.fafd05, ele.fafd06);
          }
        });
        fd.append("qid", localStorage.pid);
        fd.append("id", this.formApplyDetil.FormApply.fmap01);
        fd.append("type", type);
        const loading = this.$loading({
          lock: true,
          text: "处理中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let res = await SubmitAudit(fd);
        loading.close();
        if (res.Code > 0) {
          this.$message.success("审核成功");
          this.editFormApplyOpen = false;
          this.GetFormApply();
        }
      }
    },
    async UpdateFormApply() {
      let fd = new FormData();
      this.formApplyDetil.FormApplyFields.forEach((ele) => {
        if (ele.fafd03 == 7 && ele.fafd06 && typeof ele.fafd06 == "object") {
          ele.fafd06 = ele.fafd06.join(",");
        }
        if (ele.fafd06) {
          fd.append(ele.fafd05, ele.fafd06);
        }
      });
      fd.append("qid", localStorage.pid);
      fd.append("id", this.formApplyDetil.FormApply.fmap01);
      let res = await UpdateFormApply(fd);
      if (res.Code > 0) {
        this.$message.success("编辑成功");
        this.editFormApplyOpen = false;
        this.GetFormApply();
      }
    },
    async DelFormApply(id) {
      let res = await DelFormApply({ id, qid: localStorage.pid });
      if (res.Code) {
        this.$message.success("删除成功");
        this.GetFormApply();
      }
    },
    async CancelFormApply(id) {
      let res = await CancelFormApply({ id });
      if (res.Code) {
        this.$message.success("撤回成功");
        this.GetFormApply();
      }
    },
    viewImage(imageUrl) {
      this.viewImageShow = true;
      this.imageUrl = imageUrl;
    },
    async editFormApply(id, type) {
      this.editFormApplyOpen = true;
      this.SubmitAuditParams.id = id;
      this.GetProUsersList();
      let res = await FindFormApplyDetail({ params: { id } });
      this.formApplyDetil = res.Data;
      //   发起人和审核人 编辑 需要筛选填写的内容
      //   这里对选择人员作处理，如果是选择人员需要把 string 转 Array
      this.formApplyDetil.FormApplyFields.forEach((ele) => {
        if (ele.fafd03 == 7 && ele.fafd06 && typeof ele.fafd06 == "string") {
          ele.fafd06 = ele.fafd06.split(",");
        }
      });

      this.viewOrEdit = "Edit";
      if (type == 1) {
        this.formApplyDetil.FormApplyFields =
          this.formApplyDetil.FormApplyFields.filter((ele) => ele.fafd04 == 1);
      } else if (type == 2) {
        this.formApplyDetil.FormApplyFields =
          this.formApplyDetil.FormApplyFields.filter((ele) => ele.fafd04 == 2);
      } else {
        this.viewOrEdit = "view";
      }
    },
    async GetFormApply() {
      let params = {
        xid: localStorage.xid,
        uid: localStorage.id,
        type: this.ApplyType,
        searchword: this.searchword,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      let res = await GetFormApply({ params });
      this.formApplyList = res.Data.list;
      this.total = res.Data.total;
    },
    async PressFormApply(id) {
      let res = await PressFormApply({ id });
      if (res.Code) {
        this.$message.success("催办成功");
        this.GetFormApply();
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetFormApply();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetFormApply();
    },
    addflowChart() {
      this.addflowChartShow = true;
      this.GetFullFormTemp();
      this.GetProUsersList();
      this.GetFormAuditFlowList();
    },
    async AddFormApply() {
      if (!this.AddFormApplyParams.name) {
        this.$message.error("请输入表单名称");
        return;
      }
      if (!this.AddFormApplyParams.tempId) {
        this.$message.error("请选择表单模板");
        return;
      }
      if (!this.AddFormApplyParams.auditId) {
        this.$message.error("请选择审核流程");
        return;
      }
      let fd = new FormData();
      for (var key in this.AddFormApplyParams) {
        fd.append(key, this.AddFormApplyParams[key]);
      }
      this.tempFields.forEach((ele) => {
        if (ele.fmfd04 == 7 && ele.fmfd02 && ele.fmfd02 == "object") {
          ele.fmfd02 = ele.fmfd02.join(",");
        }
        fd.append(ele.fmfd06, ele.fmfd02);
      });

      let res = await AddFormApply(fd);
      if (res.Code) {
        this.$message.success("添加成功");
        this.addflowChartShow = false;
        this.GetFormApply();
      }
    },
    async GetFormAuditFlowList() {
      let params = {
        xid: localStorage.xid,
        searchword: "",
        pageIndex: 1,
        pageSize: 99999,
      };
      let res = await GetFormAuditFlowList({ params });
      this.AuditFlowList = res.Data.list;
      if (res.Data.list.length) {
        this.AddFormApplyParams.auditId = this.AuditFlowList[0].fafl01;
        this.GetOneFormAuditFlow(this.AddFormApplyParams.auditId);
      }
    },
    async GetOneFormAuditFlow(id) {
      let params = { id };
      let res = await GetOneFormAuditFlow({ params });
      //   fadt07 === 1 是流程 2 是抄送
      this.detailList = res.Data.detailList;
    },
    async getData(id) {
      if (id) {
        let findObj = this.zNodes.find((ele) => ele.ID == id);
        if (findObj.wopl07 !== 1) {
          this.$message.warning("只能选择单模");
        } else {
          let res = await FindWorkPlaneModel({ id });
          let modelId = res.Data.modelId;
          let res2 = await GetModelSelectOrViewPoint({
            mid: modelId,
            seachword: "",
            type:
              this.addOrEdit == 1
                ? this.fmfdObj.fmfd04 == 10
                  ? 3
                  : 1
                : this.fmfdObj.fafd03 == 10
                ? 3
                : 1,
            uid: localStorage.id,
          });
          this.selectOrViewList = res2.Data;
        }
      }
    },
    bindPicForFmfdObj(data) {
      if (data.pic) {
        if (this.addOrEdit == 1) {
          this.fmfdObj.fmfd02 = data.pic;
        } else {
          this.fmfdObj.fafd06 = data.pic;
        }
        this.modelOrView = false;
      } else {
        this.$message.warning("该选择集下无图片");
      }
    },
    async changeModelOrView(data, type) {
      this.selectOrViewList = [];
      this.addOrEdit = type;
      this.fmfdObj = data;
      this.modelOrView = true;
      let params = {
        xid: localStorage.getItem("xid"),
        pid: -1,
      };
      let res = await GetWorkPlaneTree2(params);
      this.zNodes = res.Data;
      this.zNodes.forEach((item) => {
        this.judge(item);
      });
    },
    // 判断类型
    judge(item) {
      if (item.wopl07 == 1) {
        return (item.iconSkin = "pIcon01");
      } else if (item.wopl07 == 2) {
        return (item.iconSkin = "pIcon02");
      } else if (item.wopl07 == 3) {
        return (item.iconSkin = "pIcon03");
      } else {
        return (item.iconSkin = "pIcon04");
      }
    },
    changeFile(item, file, type, type2) {
      // type  是 判断 fafd 的还是 fmfd 的 type2是添加删除
      if (type == 2) {
        item.fafd06 = file.raw;
        if (type2 == 2) {
          item.fafd06 = "";
        }
      } else {
        item.fmfd02 = file.raw;
        if (type2 == 2) {
          item.fmfd02 = "";
        }
      }
    },

    async GetProUsersList() {
      let params = {
        seachword: "",
        id: localStorage.xid,
        cid: localStorage.pid,
        bid: "null",
        pageIndex: 1,
        pageSize: 999999,
      };
      let res = await GetProUsersList({ params });
      this.userList = res.Data.list;
    },
    async GetFullFormTemp() {
      let params = {
        xid: localStorage.xid,
      };
      let res = await GetFullFormTemp({ params });

      if (res.Data.length) {
        this.formTemplist = res.Data;
        this.formTemp = res.Data[0];
        this.AddFormApplyParams.tempId = res.Data[0].fmtp01;
        this.GetOneFormTemp(this.formTemp.fmtp01);
      }
    },
    async GetOneFormTemp(id) {
      let params = {
        id,
      };
      let res = await GetOneFormTemp({ params });
      //   过滤发起人需要填写的
      this.tempFields = res.Data.tempFields.filter((ele) => ele.fmfd05 == 1);
      this.tempFields.forEach((ele) => (ele.fmfd02 = ""));
    },
    changeFormTemp(id) {
      this.formTemp = this.formTemplist.find((ele) => ele.fmtp01 == id);
      this.GetOneFormTemp(this.formTemp.fmtp01);
    },
    handleClose(done) {
      this.$confirm("确认关闭？").then((_) => {
        done();
      });
    },

    //查看流程记录
    Auditrecord() {
      this.record = true;
      this.formApplyDetil.FormAuditRecord.forEach((ele) => {
        if (ele.farc04 == "2") {
          ele.size = "large";
          ele.type = "danger";
          ele.icon = "el-icon-circle-close";
        } else {
          ele.size = "large";
          ele.type = "primary";
          ele.icon = "el-icon-circle-check";
        }
      });
    },
    //查看审核流程
    openreviewpro() {
      this.reviewprocess = true;
      this.formApplyDetil.FormAuditFlow =
        this.formApplyDetil.FormAuditFlow.filter((ele) => ele.fmad07 == 1);
    },
  },
};
</script>
<style lang="less" scoped>
.block {
  position: absolute;
  margin-top: 22px;
  margin-left: 30px;
}
/deep/.el-drawer.rtl {
  width: 25% !important;
}
.dia-card {
  .el-icon-bottom:before {
    content: "\E6EB";
    position: relative;
    margin-left: 17vh !important;
    font-size: 30px;
    top: 0px !important;
    color: #5db3f0;
  }
}
.el-body {
  p {
    color: #1177dc;
    font-size: 15px;
  }
}
.card-cont {
  text-align: center;
  margin-top: 12px;
  span {
    color: #838383;
  }
}
.div-span {
  position: relative;
  float: right;
  -webkit-transform: rotate(-30deg);
}
.el-timeline {
  position: relative;
  margin-left: 20px;
}
/deep/.card-choice {
  height: 80vh !important;
  .card-son {
    p {
      color: #1177dc;
      font-size: 15px;
    }
  }
}
.el-card__body {
  position: relative;
  padding: 20px;
  width: 35vh;
  .el-icon-bottom:before {
    content: "\E6EB";
    color: #5db3f0;
    font-size: 35px;
    position: relative;
    top: 3vh;
    margin-left: 15vh;
  }
}
/deep/.el-table .warning-row {
  background: skyblue;
}
</style>
